<template>
    <div>
        <div class="flex flex-wrap my-3">
            <div class="w-full lg:w-10/12 text-center">
                <h1 class="text-3xl">
                    Servicios para
                    {{ selectedMerchant.merchantType | merchantInfo("type") }}
                    <strong class="text-theme-primary">
                        {{ selectedMerchant.name }}
                    </strong>
                </h1>
            </div>
            <div class="w-full lg:w-2/12 flex justify-center items-center">
                <app-button
                    icon
                    circle
                    color="brand-purple"
                    @click="listMerchantsServiceComponent"
                >
                    <reload-icon class="h-5 w-5 text-white" />
                </app-button>
            </div>
        </div>

        <div>
            <span>
                En esta sección, puedes registrar los servicios adicionales que
                ofreces en tu tienda, como el laminado de carnets o la
                realización de fotocopias, podrás usar los servicios registrados
                en tus ventas. Es importante tener en cuenta que las ventas
                generadas a través de estos servicios no impactan el inventario
                de tu tienda.
            </span>
        </div>

        <div v-if="isLoading" class="flex justify-center">
            <span class="my-3"> Cargando... </span>
        </div>

        <div v-else>
            <services-in-merchant-manage
                v-model="services"
                :enabled="$ability.hasPermission('merchant:UpdateServices')"
                class="mt-4"
            />
            <div class="flex flex-wrap mt-4">
                <div class="w-full flex justify-center">
                    <app-button @click="updateServicesMerchantComponent">
                        Actualizar servicios
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import ServicesInMerchantManage from "@/components/utils/ServicesInMerchantManage.vue";

export default {
    name: "ServicesDetails",
    components: {
        ServicesInMerchantManage,
        ReloadIcon
    },
    data: () => ({
        services: [],
        isLoading: false
    }),
    computed: {
        ...mapState("commons", ["selectedMerchant"]),
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {},
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (
            !(await verifyPagePermission("merchant:ListServices", "/app", true))
        )
            return;
        await this.listMerchantsServiceComponent();
    },
    methods: {
        ...mapActions("merchants", [
            "listServicesMerchant",
            "updateServicesMerchant"
        ]),
        async listMerchantsServiceComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                const services = await this.listServicesMerchant({
                    merchantId: this.selectedMerchant.merchantId,
                    merchantType: this.selectedMerchant.merchantType
                });
                this.services = services.map((item) => ({
                    name: item.product.name,
                    priceOffer: item.priceOffer
                }));
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateServicesMerchantComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateServicesMerchant({
                    merchantId: this.selectedMerchant.merchantId,
                    merchantType: this.selectedMerchant.merchantType,
                    services: this.services.map((item) => ({
                        appliedDiscountPerReference: 0,
                        priceOffer: item.priceOffer,
                        product: {
                            name: item.name
                        },
                        quantity: 1,
                        id: 0
                    }))
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
